'use client'

import { ButtonVariantClasses, ButtonVariants } from '../../components'
import {
    AnalyticsEventType,
    ContentInteractionAnalyticsEvent,
    findParentElement,
    getSectionFromElement,
    NavigationAnalyticsEvent,
    sendAnalyticsEvent,
} from '../../../../MyStichtingOpenHelpers/src/static'
/* eslint-disable */
import React, { useEffect } from 'react'

const getAllText = (node: HTMLElement): string => {
    return node.textContent?.trim() || ''
}

const getButtonLinkText = (button: HTMLElement): string => {
    const text = getAllText(button)
    if (text) return text
    return button.getAttribute('aria-label')?.trim() || ''
}

const getButtonSubtype = (
    button: HTMLElement,
):
    | 'button_primary'
    | 'button_secondary'
    | 'button_quiet'
    | 'button_tertiary'
    | 'danger_primary'
    | 'danger_secondary'
    | 'danger_quiet'
    | '' => {
    const className = button.className || ''
    if (className.includes(ButtonVariantClasses[ButtonVariants.PRIMARY])) return 'button_primary'
    if (className.includes(ButtonVariantClasses[ButtonVariants.SECONDARY])) return 'button_secondary'
    if (className.includes(ButtonVariantClasses[ButtonVariants.TERTIARY])) return 'button_tertiary'
    if (className.includes(ButtonVariantClasses[ButtonVariants.QUIET])) return 'button_quiet'
    if (className.includes(ButtonVariantClasses[ButtonVariants.DANGER_PRIMARY])) return 'danger_primary'
    if (className.includes(ButtonVariantClasses[ButtonVariants.DANGER_SECONDARY])) return 'danger_secondary'
    if (className.includes(ButtonVariantClasses[ButtonVariants.DANGER_QUIET])) return 'danger_quiet'
    return ''
}

const getButtonClickEventObject = (button: HTMLElement) => {
    const text = getButtonLinkText(button)
    const event: ContentInteractionAnalyticsEvent = {
        event: AnalyticsEventType.CONTENT_INTERACTION,
        interaction_type: 'click',
        tm_type: '',
        tm_section: getSectionFromElement(button),
        tm_element: getButtonSubtype(button),
        link_text: text,
        link_url: '',
    }
    return event
}
const getLinkClickEventObject = (link: HTMLElement) => {
    const text = getAllText(link)
    const href = (link as HTMLAnchorElement).href || ''
    const event: NavigationAnalyticsEvent = {
        event: AnalyticsEventType.NAVIGATION,
        interaction_type: 'click',
        tm_section: getSectionFromElement(link),
        tm_component: '',
        tm_index: '',
        tm_element: 'link',
        link_text: text,
        link_url: href,
        search_term: '',
    }

    return event
}

const sendButtonClickEvent = (button: HTMLElement) => {
    const event = getButtonClickEventObject(button)
    sendAnalyticsEvent(event)
}

const sendLinkClickEvent = (link: HTMLElement) => {
    const event = getLinkClickEventObject(link)
    sendAnalyticsEvent(event)
}
/**
 * This hook is used to send GA4 analytics events for click events on buttons and links.
 */
export const useClickAnalytics = () => {
    const handleClick = (event: MouseEvent) => {
        const target = event.target as HTMLElement | null
        if (!target) return

        const buttonResult = findParentElement(target, 'button')
        if (buttonResult) {
            if (findParentElement(target, 'form') || ('form' in buttonResult.element && !!buttonResult.element.form))
                return
            sendButtonClickEvent(buttonResult.element)
            return
        }

        const linkResult = findParentElement(target, 'a')
        if (linkResult) {
            sendLinkClickEvent(linkResult.element)
        }
    }

    useEffect(() => {
        document?.addEventListener('click', handleClick)

        return () => {
            document?.removeEventListener('click', handleClick)
        }
    }, [])

    return {}
}
